"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarlyColonization = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
const BuildColony_1 = require("../../deferredActions/BuildColony");
class EarlyColonization extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.EARLY_COLONIZATION,
            tags: [Tags_1.Tags.SPACE],
            metadata: {
                cardNumber: 'P48',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.colonies(1);
                    b.energy(3);
                    b.br;
                    b.text('RAISE ALL COLONY TRACKS 2 STEPS');
                }),
                description: 'Place a colony. Gain 3 energy.',
            },
        });
    }
    canPlay(player) {
        return player.hasAvailableColonyTileToBuildOn();
    }
    play(player) {
        player.addResource(Resources_1.Resources.ENERGY, 3);
        const activeColonies = player.game.colonies.filter((colony) => colony.isActive);
        activeColonies.forEach((colony) => colony.increaseTrack(2));
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select colony for Early Colonization'));
        return undefined;
    }
}
exports.EarlyColonization = EarlyColonization;
//# sourceMappingURL=EarlyColonization.js.map